import { get, post } from '@/utils/http/http'
import {
  LIVE_MEETING_URL,
  LIVE_MAIN,
  SUBSCRIBE_URI
} from '@/utils/http/baseUrl'

// 获取活动详情信息
export const GetActivityInfoCache = activityId =>
  get(
    `${LIVE_MEETING_URL}/api/MeetingActivityService/GetActivityInfoCache?activityId=${activityId}`,
    null,
    false
  )

// 获取会议活动嘉宾列表
export const GetActivityGuestsCache = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingActivityService/GetActivityGuestsCache`,
    params,
    false
  )

// 获取日程时间列表
export const GetScheduleTimesCache = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingActivityService/GetScheduleTimesCache`,
    params,
    false
  )

// 获取日程详情列表
export const GetMeetingSchedulesCache = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingActivityService/GetMeetingSchedulesCache`,
    params,
    false
  )

// 获取购票调查
export const WxFormInfoList = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingFormInfoService/WxFormInfoList`,
    params,
    false
  )

// 获取票券列表
export const WxTicketInfoList = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingTicketInfoService/WxTicketInfoList`,
    params,
    false
  )

// 获取用户票券
export const SignUpList = params =>
  post(`${LIVE_MEETING_URL}/api/MeetingSignUpService/SignUpList`, params, false)

// 检查购票的基础条件
export const IsLimitPurchase = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingSignUpService/IsLimitPurchase`,
    params,
    false
  )

// 用户报名下单
export const SaveUserSignUp = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingSignUpService/SaveUserSignUp`,
    params,
    false
  )

// 用户下单支付
export const PayUserSignUp = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingSignUpService/PayUserSignUp`,
    params,
    false,
    {
      allResolve: true
    }
  )

// 检测用户是否有未支付票券
export const InspectUserPayment = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingSignUpService/InspectUserPayment`,
    params,
    false
  )

// 用户重新付款
export const PaymentUserSignUp = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingSignUpService/PaymentUserSignUp`,
    params,
    false
  )

// 用户取消付款订单
export const CancelPaymentUserSignUp = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingSignUpService/CancelPaymentUserSignUp`,
    params,
    false
  )

// 获取参展商分页
export const MeetingExhibitorSearchWx = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingTopicService/MeetingExhibitorSearchWx`,
    params,
    false
  )

// 支付接口(PC)
export const PcPayment = params =>
  post(`/live/payment?t=2`, params, false, {
    contentType: 'application/json;charset=UTF-8'
  })

// 支付接口(WX)
export const WxPayment = params =>
  post(`/live/payment?t=1`, params, false, {
    contentType: 'application/json;charset=UTF-8'
  })

// 检查支付状态
export const getPayState = params =>
  post(`/liveajax/GetPayState`, params, false, {
    contentType: 'application/json;charset=UTF-8'
  })

// 获取参展商详情
export const getMeetingExhibitorDetail = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingTopicService/MeetingExhibitorInfoWx`,
    params,
    false
  )

// 用户票券签到
export const SaveSignInStatus = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingSignUpService/SaveSignInStatus`,
    params,
    false
  )

// 获取参展商已绑定的话题
export const MeetingTopicSearchWx = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingTopicService/MeetingTopicSearchWx`,
    params,
    false
  )

// 更改票券分享状态
export const TicShareStatus = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingSignUpService/TicShareStatus`,
    params,
    false
  )

// 领取票券
export const ReplaceUserSignUp = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingSignUpService/ReplaceUserSignUp`,
    params,
    false
  )

// 获取票券详情
export const WxTicketInfo = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingTicketInfoService/WxTicketInfo`,
    params,
    false
  )

// 获取关联的小组讨论列表
export const getmeetinglist = activityid =>
  get(
    `${LIVE_MAIN}/api/trtcmeeting/mt_getmeetinglist?activityid=${activityid}`,
    null,
    false
  )
// 检查用户有没有订阅活动开始提醒消息
export const CheckIsSubscribe = params =>
  post(`${SUBSCRIBE_URI}/pushservice/msgPush/CheckIsSubscribe`, params, false)

// 获取直播间具体场景的模板配置
export const GetSubscribeConfig = zbid =>
  get(
    `${SUBSCRIBE_URI}/pushservice/msgPush/GetSubscribeConfig?zbid=${zbid}&scene=2`,
    null,
    false
  )

// 获取审核票模板配置
export const GetSubscribeConfig1 = zbid =>
  get(
    `${SUBSCRIBE_URI}/pushservice/msgPush/GetSubscribeConfig?zbid=${zbid}&scene=3`,
    null,
    false
  )

// 用户预约活动开始提醒
export const SubscribeMsg = params =>
  post(`${SUBSCRIBE_URI}/pushservice/msgPush/SubscribeMsg`, params, false)

// 检查用户是否持有该小组的门票
export const CheckIsExistSignUp = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingTicketInfoService/CheckIsExistSignUp`,
    params,
    false
  )

// 获取某一张门票支持的小组讨论列表
export const GetListByTicketid = (activityid, ticketid) =>
  get(
    `${LIVE_MAIN}/api/trtcmeeting/mt_getlistbyticketid?activityid=${activityid}&ticketid=${ticketid}`,
    null,
    false
  )

// 获取分享信息
export const GetMeetingActivityShareCache = params =>
  get(
    `${LIVE_MEETING_URL}/api/MeetingActivityService/GetMeetingActivityShareCache`,
    params,
    false
  )

// 获取用户信息
export const UserInfo = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingSignUpService/UserInfo?enc_id=${params.id}`,
    params,
    false
  )

// 获取三方信息(主办方/协办方/赞助方)
export const GetMeetingSponsorsCache = ActivityId =>
  get(
    `${LIVE_MEETING_URL}/api/MeetingActivityService/GetMeetingSponsorsCache?ActivityId=${ActivityId}`,
    null,
    false
  )

// 获取导航列表
export const GetMeetingNavigationsCache = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingActivityService/GetMeetingNavigationsCache`,
    params,
    false
  )

// 获取展商/展品分类记录
export const MeetingClassify = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingProductService/MeetingClassify`,
    params,
    false
  )

// 获取展品基础信息
export const MeetingProductList = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingProductService/MeetingProductList`,
    params,
    false
  )

// 设置活动浏览记录
export const setBrowseCountCache = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingActivityService/setBrowseCountCache`,
    params,
    false
  )

// 添加用户浏览记录
export const UserBrowseAddWx = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingActivityService/UserBrowseAddWx`,
    params,
    false
  )

// 获取快捷导航列表
export const WxQuickNavList = params =>
  post(
    `${LIVE_MEETING_URL}/api/MeetingActivityService/WxQuickNavList`,
    params,
    false
  )
